module.exports = __webpack_public_path__ + "static/media/Magnifier_Hovered.872b3668.svg";